// @mui
import {
  Box,
  Stack,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import {
  FieldErrors,
  UseFormRegister,
  UseFormGetValues,
} from "react-hook-form";
// styling
import styles from "src/components/UI/Profile/assets/scss/Profile.module.scss";

interface FormObject {
  user_name: any;
  profession: any;
  first_name: any;
  last_name: any;
  email: any;
  bio: any;
  street: any;
  city: any;
  state: any;
  country: any;
  zip_code: any;
}
interface AddressEditProps {
  errors: FieldErrors<FormObject>;
  register: UseFormRegister<FormObject>;
  // getValues: {
  //   street: any;
  //   city: any;
  //   state: any;
  //   country: any;
  //   zip_code: any;
  // };
  // getValues: UseFormGetValues<{
  //   user_name: any;
  //   profession: any;
  //   first_name: any;
  //   last_name: any;
  //   email: any;
  //   bio: any;
  //   street: any;
  //   city: any;
  //   state: any;
  //   country: any;
  //   zip_code: any;
  // }>;
}
const AddressEdit = ({ errors, register }: AddressEditProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1} alignItems="flex-start" sx={{ p: 0 }}>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Street address
            </Typography>
            <TextField
              {...register("street", {
                pattern: {
                  value: /^[^\n]*$/,
                  message: "Street address should not contain new lines.",
                },

                maxLength: {
                  value: 100,
                  message: "Street address should not exceed 100 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.street}
              helperText={errors.street?.message?.toString()}
            />
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              City
            </Typography>
            <TextField
              {...register("city", {
                pattern: {
                  value: /^[A-Za-z][A-Za-z]*$/,
                  message: "City should contain letters only.",
                },
                minLength: {
                  value: 3,
                  message: "City should be at least 3 characters.",
                },
                maxLength: {
                  value: 50,
                  message: "City should not exceed 50 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.city}
              helperText={errors.city?.message?.toString()}
            />
          </div>
        </Box>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              State
            </Typography>
            <TextField
              {...register("state", {
                pattern: {
                  value: /^[A-Za-z][A-Za-z]*$/,
                  message: "State should contain letters only.",
                },
                minLength: {
                  value: 3,
                  message: "State should be at least 3 characters.",
                },
                maxLength: {
                  value: 50,
                  message: "State should not exceed 50 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.state}
              helperText={errors.state?.message?.toString()}
            />
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Country
            </Typography>
            <TextField
              {...register("country", {
                pattern: {
                  value: /^[A-Za-z][A-Za-z]*$/,
                  message: "Country should contain letters only.",
                },
                minLength: {
                  value: 3,
                  message: "Country should be at least 3 characters.",
                },
                maxLength: {
                  value: 50,
                  message: "Country should not exceed 50 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.country}
              helperText={errors.country?.message?.toString()}
            />
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Zip code
            </Typography>
            <TextField
              {...register("zip_code", {
                pattern: {
                  value: /^\d{5}$|^\d{5}-\d{4}$/,
                  message:
                    "Zip code consists of 5 digits or 5 digits followed by a hyphen and 4 digits.",
                },
                minLength: {
                  value: 5,
                  message: "Zip code should be at least 5 digits.",
                },
                maxLength: {
                  value: 10,
                  message: "Country should not exceed 10 digits.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.zip_code}
              helperText={errors.zip_code?.message?.toString()}
              sx={{
                "& .MuiFormHelperText-root": {
                  width: "200%",
                },
              }}
            />
          </div>
        </Box>
      </Stack>
    </Box>
  );
};
export default AddressEdit;
